import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { getContactModalTranslations } from '../../translations/contactModal';
import ContactModalBase from './ContactModalBase';

interface ContactModalProps {
    isOpen: boolean;
    onClose: () => void;
}

function ContactModal({ isOpen, onClose }: ContactModalProps) {
    const { language } = useLanguage();
    const translations = getContactModalTranslations(language);

    return (
        <ContactModalBase
            isOpen={isOpen}
            onClose={onClose}
            translations={translations}
            phoneNumber="+41 41 525 25 33"
            emailAddress="contact@niveau-eleve.ch"
        />
    );
}

export default ContactModal; 